import { cloneProviderClient, unwrap } from './cloneProviderClient';

// axios mặc định serialize array param thành "key[]=a&key[]=b" - FastAPI's
// Query(list[...]) không nhận dạng tên có "[]", cần đúng "key=a&key=b" lặp
// lại. Không route nào hiện nhận param dạng list nữa, nhưng giữ serializer
// này cho listAccounts() để an toàn nếu có filter dạng list trong tương lai.
function serializeParams(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => search.append(key, v));
    } else {
      search.append(key, value);
    }
  });
  return search.toString();
}

export async function listAccounts(params = {}) {
  const response = await cloneProviderClient.get('/admin/accounts', { params, paramsSerializer: serializeParams });
  return unwrap(response);
}

export async function getAccount(uid) {
  const response = await cloneProviderClient.get(`/admin/accounts/${encodeURIComponent(uid)}`);
  return unwrap(response);
}

export async function deleteAccount(uid) {
  const response = await cloneProviderClient.delete(`/admin/accounts/${encodeURIComponent(uid)}`);
  return unwrap(response);
}

export async function addAccounts({ website, productName, unitVnd, dataText }) {
  // Backend nhận data_text qua Body(...) không bọc Pydantic model - FastAPI
  // mong đợi body là JSON-encoded string (có quotes bao quanh), không phải
  // raw text/plain.
  const response = await cloneProviderClient.post(
    '/admin/accounts',
    JSON.stringify(dataText),
    {
      params: { website, product_name: productName, unit_vnd: unitVnd },
      headers: { 'Content-Type': 'application/json' },
    }
  );
  return unwrap(response);
}

export async function createDeletingRequest(filters) {
  const response = await cloneProviderClient.post('/admin/accounts/deleting-requests', null, { params: filters });
  return unwrap(response);
}

export async function cancelDeletingRequest(token) {
  const response = await cloneProviderClient.post(`/admin/accounts/deleting-requests/${encodeURIComponent(token)}/cancel`);
  return unwrap(response);
}

export async function confirmDeletingRequest(token) {
  const response = await cloneProviderClient.post(`/admin/accounts/deleting-requests/${encodeURIComponent(token)}/confirm`);
  return unwrap(response);
}

const accountsService = {
  listAccounts,
  getAccount,
  deleteAccount,
  addAccounts,
  createDeletingRequest,
  cancelDeletingRequest,
  confirmDeletingRequest,
};
export default accountsService;
